import { render } from "./UserSelection.vue?vue&type=template&id=d20590ce"
import script from "./UserSelection.vue?vue&type=script&lang=js"
export * from "./UserSelection.vue?vue&type=script&lang=js"

import "./UserSelection.vue?vue&type=style&index=0&id=d20590ce&scope=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__